import styled from 'styled-components';

import React, { useMemo } from 'react';
import { Colors } from 'styles/theme';

export const CSSProgressBarWrapper = styled.div`
    width: 100%;
    height: 14px;
    background-color: ${(props) => props.theme.color.grey1};
    border-radius: ${(props) => props.theme.space.md}px;
`;
export const CSSProgressBar = styled.div<{ width: number; color: string }>`
    width: ${(props) => props.width}%;
    transition: all 0.2s ease-out;
    height: 14px;
    opacity: 0.4;
    background-color: ${(props) => props.color};
    border-radius: ${(props) => props.theme.space.md}px;
`;

export type JRCProgressBarProps = {
    value: number;
    total: number;
    threshold?: number;
    colorProgressBar?: Colors;
};

export const JRCProgressBar = ({ value, total, threshold = 0.8, colorProgressBar }: JRCProgressBarProps) => {
    const width = useMemo(() => (value === 0 ? 0 : (value * 100) / total), [value, total]);
    const color = useMemo(() => {
        if (colorProgressBar) return colorProgressBar;
        if (value === total) return 'orange';
        if (value === Math.floor(total * threshold)) return 'yellow';
        return 'green';
    }, [total, value, threshold, colorProgressBar]);

    return (
        <CSSProgressBarWrapper>
            <CSSProgressBar width={width} color={color} />
        </CSSProgressBarWrapper>
    );
};
